// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__10CkH","insightsList":"newBusinessInsightsMenu_insightsList__1DzG5","active":"newBusinessInsightsMenu_active__32tGG"};